module.exports = __webpack_public_path__ + "static/media/role-setup.189c614a.svg";